"use client";

import { Field, Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import * as Yup from "yup";
import CustomButton from "../../common/CustomButton";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../../../utils/constants";
import { verifyCaptcha } from "../../../utils/server-actions";
import PopUpModal from "../../common/PopUpModal";
import { SuccessfulPage } from "../../common/SuccessfulPage";
import Loading from "../../../app/loading";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const recaptchaRef = useRef();
  const [token, setToken] = useState("");
  const [isVerified, setIsverified] = useState(false);
  const [success, setSuccess] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    status: "",
  });

  const initial = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    message: "",
    resume: null,    // NEW
  };

  async function handleCaptchaSubmission(token) {
    await verifyCaptcha(token)
      .then((d) => {
        if (d) {
          setToken(d);
          setIsverified(true);
        } else {
          setToken("");
          setIsverified(false);
        }
      })
      .catch(() => {
        setToken("");
        setIsverified(false);
      });
  }

  const validation = Yup.object().shape({
    firstName: Yup.string().required("First name is required!"),
    lastName: Yup.string().required("Last name is required!"),
    phoneNumber: Yup.string()
      .matches(/^\d{10}$/, "Invalid phone number format.")
      .required("Phone number is required!"),
    email: Yup.string().email("Invalid email format").required("Email is required!"),
    message: Yup.string().required("Additional info required!"),
    resume: Yup.mixed()
  .required("Resume/CV is required!")
  .test("fileSize", "File too large", (value) => {
    return value && value.size <= 5 * 1024 * 1024; // 5MB
  })
  .test("fileFormat", "Unsupported file format", (value) => {
    return (
      value &&
      ["application/pdf", "application/msword", 
       "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
        .includes(value.type)
    );
  }),
  });

  const Label = ({ title }) => (
    <p
      className="f-w-400  font-nunito-sans p-16 color-black form-label"
      style={{
        marginBottom: "5px",
      }}
    >
      {title}
      <span style={{ color: "red" }}> *</span>
    </p>
  );

  const handleOnSubmit = async (values, { resetForm }) => {
    console.log("Form submitted: ", values);
    setLoading(true);
    try {

      const formData = new FormData();
        Object.keys(values).forEach((key) => {
          formData.append(key, values[key]);
        });

      // const response = await fetch("/api/general-contact", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(values),
      // });

      const response = await fetch("/api/general-contact", {
        method: "POST",
        body: formData,
      });

      let apiResponse;
      try {
        apiResponse = await response.json();
      } catch (jsonError) {
        throw new Error("Invalid JSON response from server");
      }

      console.log("Response from API:", apiResponse);

      if (response.ok) {
        // Google Ads Conversion Tracking
        if (typeof window !== 'undefined' && window.gtag) {
          window.gtag('set', 'user_data', {
            email: values.email,
            phone_number: "+1" + values.phoneNumber.replace(/\D/g, '')
          });
          window.gtag('event', 'conversion', {
            send_to: 'AW-18483649982/sX_JCI7oy5MdEL672O1E'
          });
        }

        setModalData({
          title: "Successful!",
          message: "Thank you for reaching out! We'll get back to you soon.",
          status: "success",
        });
        resetForm();
      } else {
        console.log(`Error: ${apiResponse.error || "Something went wrong"}`);
        setModalData({
          title: "Error!",
          message: apiResponse.error || "Something went wrong",
          status: "err",
        });
      }
    } catch (errors) {
      console.error("Unexpected error:", errors);
      setModalData({
        title: "Sorry :(",
        message: "An unexpected error occurred. Please try again later.",
        status: "err",
      });
    } finally {
      setLoading(false);
      recaptchaRef.current?.reset();
      setToken("");
      setIsverified(false);
      setShowModal(true);
    }
  };

  return (
    <>
      <div className="form b-r-10">
        <Formik initialValues={initial} validationSchema={validation} onSubmit={handleOnSubmit}>
        {({ errors, values, touched, setFieldValue }) => (

            <Form>
              <div className="flex  form-data">
                <div className="">
                  <Label title="First Name" />
                  <Field
                    name="firstName"
                    type="text"
                    placeholder="First Name"
                    className={`field-box ${errors.firstName && touched.firstName ? "error" : ""}`}
                  />
                  {errors.firstName && touched.firstName && <div className="error-message"></div>}
                </div>
                <div className="">
                  <Label title="Last Name" />
                  <Field
                    name="lastName"
                    type="text"
                    placeholder="Last Name"
                    className={`field-box ${errors.lastName && touched.lastName ? "error" : ""}`}
                  />
                  {errors.lastName && touched.lastName && <div className="error-message"></div>}
                </div>
              </div>

              <div className="flex form-data">
                <div className="">
                  <Label title="Phone Number" />
                  <Field
                    name="phoneNumber"
                    type="text"
                    placeholder="Phone"
                    className={`field-box ${errors.phoneNumber && touched.phoneNumber ? "error" : ""}`}
                  />
                  {errors.phoneNumber && touched.phoneNumber && <div className="error-message"></div>}
                </div>
                <div className="">
                  <Label title="Email" />
                  <Field name="email" type="text" placeholder="Last Name" className={`field-box ${errors.email && touched.email ? "error" : ""}`} />
                  {errors.email && touched.email && <div className="error-message"></div>}
                </div>
              </div>
              <div className="flex form-data">
                <div className="col-1-1">
                  <Label title="Upload Resume/CV" />
                  <input
                    name="resume"
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => {
                      setFieldValue("resume", e.target.files[0]);
                    }}
                    style={{maxWidth:'100%'}}
                    className={`field-box ${errors.resume && touched.resume ? "error" : ""}`}
                  />
                  {errors.resume && touched.resume && (
                    <div className="error-message">{errors.resume}</div>
                  )}
                </div>
              </div>

              <div className="flex ">
                <div className=" col-1-1">
                  <Label title="Additional Information" />
                  <Field
                    name="message"
                    as="textarea"
                    placeholder="Enter Any Additional Details Here..."
                    className={`field-textbox  ${errors.message && touched.message ? "error" : ""}`}
                  />
                  {errors.message && touched.message && <div className="error-message"></div>}
                </div>
              </div>
              <div className="recap">
                <ReCAPTCHA ref={recaptchaRef} size="normal" sitekey={RECAPTCHA_SITE_KEY} onChange={handleCaptchaSubmission} />
              </div>
              {console.log("ddddd " ,  loading , !isVerified , !values.firstName, !values.lastName ,!values.phoneNumber , !values.email, !values.message,  !values.resume)}
              <div style={{ marginTop: "10px" }}>
                <CustomButton
                  style={{ width: "100%", border: "1px solid #0b75b7", }}
                  type="submit"
                  theme="primary"
                  loading={loading}
                  disabled={
                    loading || !isVerified || !values.firstName || !values.lastName || !values.phoneNumber || !values.email || !values.message ||  !values.resume    // ⬅️ add this
                    //   !values.medicalSpecialization ||
                    //   !values.yearOfExpiry ||
                    //   !values.currentMedicalInstitution ||
                    //   !values.preferredSurgeries.length > 0
                  }
                  title="Submit Now"
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {showModal && (
        <PopUpModal onClose={() => setShowModal(false)}>
          <SuccessfulPage modalData={modalData} onClose={() => setShowModal(false)} />
        </PopUpModal>
      )}
    </>
  );
};

export default ContactForm;
